import React, { useEffect, useState } from "react";
import Routes from "../../constants/Routes";
import { Grid, Paper } from "@material-ui/core";
import AssetReview from "../AssetReview";
import Error from "../../common/lib/Error";
import APIErrorProvider from "../../common/lib/APIError/ErrorProvider";
import APIErrorNotification from "../../common/lib/APIError/ErrorNotification";
import TopBar from "../TopBar";
import Home from "../../components/Home";
import {
	getStageName,
	getQueueName,
	getStageQueues,
} from "../../constants/Actions";
import * as Queue from "../../constants/Queue";
import { makeStyles } from "@material-ui/core/styles";
// import APIErrorNotification from "../../common/lib/APIError/ErrorNotification";
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from "react-router-dom";

import SearchAppContext from "../../common/lib/ApplicationQueue/searchedAppContext";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(0),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
}));

const App = (props) => {
	const classes = useStyles();
	if (props.authProvider) window.authProvider = props.authProvider;
	const LandingPage = () => <Home linkItems={getStageQueues(Queue.ASSET)} setStageName={setStageName} />;

	const [stageName, setStageName] = useState('');
	const [actionType, setActionType] = useState({});

	useEffect(() => {
		document.title=stageName;
	}, [stageName]);

	useEffect(() => {       
        window.handleContainerAppSelection({});
    }, [stageName]);

	const [searchedQueue, setSearchedQueue] = React.useState([]);
	const [searchedApp, setSearchedApp] = React.useState("");

	const contextValue = {
		searchedQueue,
		searchedApp,
		setSearchedQueue,
		setSearchedApp,
	};

	return (
		<SearchAppContext.Provider value={contextValue}>
			<Grid container spacing={0}>
				{props.authProvider ? (
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<TopBar
								stage={stageName}
								isReadOnly={actionType.action === "View" ? true : false}
							/>
						</Paper>
					</Grid>
				) : (
					""
				)}
				<Grid align="center" item xs={12}>
					<APIErrorProvider>
						<Router>
							<Switch>
								<Route path={Routes.ASSET_REVIEW()} exact>
									<AssetReview
										setStageName={setStageName}
										actionType={actionType}
										setActionType={setActionType}
									/>
								</Route>
								<Route path={Routes.HOME()} component={LandingPage} exact />
								<Route>
									<Error code="404" message="Not Found" />
								</Route>
							</Switch>
						</Router>
						<APIErrorNotification />
					</APIErrorProvider>
				</Grid>
			</Grid>
		</SearchAppContext.Provider>
	);
};
export default App;
